import { defineAsyncComponent as r, resolveComponent as a, createElementBlock as n, openBlock as d, normalizeClass as s, renderSlot as c, createVNode as l } from "vue";
import { _ as m } from "./main-BMmugWNt.js";
const p = {
  name: "CodeNode",
  components: {
    CodeNodeRender: r(
      () => import("./CodeNodeRender-CGhuxUNs.js")
    )
  },
  props: {
    modelValue: {
      type: Object
    }
  },
  computed: {
    node() {
      return this.modelValue;
    },
    customClasses() {
      var e;
      return ((e = this.node.properties) == null ? void 0 : e.customClasses) || [];
    },
    anchorTag() {
      var e;
      return ((e = this.node.properties) == null ? void 0 : e.anchorTag) || "";
    }
  }
};
function u(e, _, i, C, f, o) {
  const t = a("CodeNodeRender");
  return d(), n("div", {
    class: s(["pb-embed", o.customClasses]),
    "data-anchor-tag": o.anchorTag
  }, [
    c(e.$slots, "default", {}, () => [
      l(t, { "model-value": o.node }, null, 8, ["model-value"])
    ], !0)
  ], 10, ["data-anchor-tag"]);
}
const g = /* @__PURE__ */ m(p, [["render", u], ["__scopeId", "data-v-996ec54a"]]);
export {
  g as default
};
